<script>
    import Errors from '../../core/Errors';
    import Behaviour from '../../core/Behaviour';
    import EventMixin from '../../mixins/EventMixin';
    import AjaxCaller from '../../mixins/AjaxCaller';
    import Validator from '../../core/Validator/Validator';
    export default {
        mixins: [AjaxCaller],
        props: {
            inputs: {
                type: Object,
                required: true
            },
            validationBag: {
                type: Object,
                required: true
            },
            behaviourBag: {
                type: String,
                required: true
            },
            group: {
                type: String,
                required: true
            },
            customProperties: {
                type: Object,
                required: false
            },
            save: {
                type: Boolean,
                default: false
            },
            fetchOptions: {
                type: Object,
                default: () => { return {} }
            }
        },
        data() {
            return {
                fields: this.inputs,
                errors: new Errors,
                behaviour: new Behaviour(this.behaviourBag),
                validator: null,
                eventMixin: new EventMixin(this.group),
                custom: this.customProperties,
            }
        },
        mounted() {
            this.fetch();
            this.validator = new Validator(this, this.validationBag);
            EventHandler.listen(this.eventMixin.target('trigger'), () => {
                this.submit();
            });
            EventHandler.listen(this.eventMixin.target('refresh'), data => {
                this.refresh(data);
            });
            EventHandler.listen(this.eventMixin.target('close-form'), () => {
                this.errors.clear();
            });
        },
        methods: {
            fetch() {
                if (Object.keys(this.fetchOptions).length === 0) {
                    return;
                }
                let request = {
                    url: this.fetchOptions.url,
                    method: this.fetchOptions.method,
                };

                if (this.fetchOptions.data) {
                    if (this.fetchOptions.method.toLowerCase() === 'post') {
                        request.data = this.fetchOptions.data;
                    } else {
                        request.params = this.fetchOptions.data;
                    }
                }

                axios.request(request)
                    .then(response => {
                        EventHandler.fire(this.fetchOptions.event, response.data);
                    })
                    .catch(console.log);
            },
            requestData() {
                return this.fields;
            },
            reset() {
                window._.forEach(this.fields, (value, key) => {
                    this.fields[key] = '';
                });
            },
            refresh(data) {
                if (data.inputs) {
                    this.fields = data.inputs;
                }
                if (data.behaviourBag) {
                    this.behaviour = data.behaviourBag;
                }
                if (data.validationBag) {
                    this.validator = new Validator(this, data.validationBag);
                }
                this.errors.clear();
                EventHandler.fire(this.eventMixin.target('refresh-fields'), this.fields);
            },
            invalidClass(indexes) {
                return {
                    invalid: this.errors.has(indexes)
                };
            },
            startProcessingEvent() {
                EventHandler.fire(this.eventMixin.target('start'));
            },
            stopProcessingEvent() {
                EventHandler.fire(this.eventMixin.target('stop'));
            },
            submit() {
                this.errors.clear();
                if (!this.validator.passes()) {
                    EventHandler.fire('top-warning', {
                        id: 1,
                        message: 'The given data was invalid.'
                    });
                    return;
                }
                this.saveData();
                this.makeCall(this.success, this.failure);
            },
            saveData() {
                if (!this.save) {
                    return;
                }
                let ls = this.$localStorage.get(this.group, null);
                if (ls === null) {
                    ls = {};
                } else {
                    ls = window.JSON.parse(ls);
                }
                this.$localStorage.set(
                    this.group,
                    window.JSON.stringify(Object.assign(ls, this.requestData()))
                );
            },
            success(response) {
                EventHandler.fire(this.eventMixin.target('success'));
                this.behaviour.run(this, response);
            },
            failure(error) {
                this.stopProcessing();
                EventHandler.fire(this.eventMixin.target('failure'));
                if (error.response && error.response.data) {
                    EventHandler.fire('top-warning', {
                        id: 1,
                        message: error.response.data.message
                    });
                    error = error.response.data.errors;
                }
                this.errors.record(error);
            }
        }
    };
</script>